import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Title = styled.div`
  font-size: 16px;
  margin-left: 12px;
`

export const InfoIconWrapper = styled.div`
  display: flex;

  svg {
    width: 22px;
    height: 22px;
  }
`
